import React, { useEffect, useState } from 'react'
import FormRender from '../../components/FormRender'
import { FORM_SETTING_COMPANY_NEWS } from '../../helper'
import useAxiosInstance from '../../hooks/useAxios'
import { toast } from 'react-toastify'
import { useNavigate, useSearchParams } from 'react-router-dom'

const AddEditCompanyNews = () => {
    const [formData, setFormData] = useState({
        "permalink":"",
        "title":"",
        "author":"",
        "url":"",
        "publisher":"",
        "published_date":"",
    })
    const [loading,setLoading] = useState(false)
    const history = useNavigate()
    const axiosInstance = useAxiosInstance();
    const [searchParams,setSearchParams] = useSearchParams()
    const pk = searchParams.get('pk')
    const [pageLoader, setPageLoader] = useState(false);

    useEffect(()=>{
        if(!pk){
            return 
        }
        setPageLoader(true);
        axiosInstance
        .post(`/news/get_a_company_news/`,
            {   
                "pk":pk
            }
        )
        .then((res) => {
            setFormData(res.data.data);
            setPageLoader(false)
        })
        .catch((err) => {
            console.log(err);
            toast.error("Something went while getting orgs");
            setPageLoader(false);
        });
    },[])

    return (
        <div>
        <div className="mr-4  p-3 my-5 border rounded-lg bg-white">
            <p className="text-2xl flex items-center justify-between text-black font-medium mb-4">
                <p>Company News</p>
            </p>
            {pageLoader? <p>Loading...</p>:<>
            <FormRender
                formData={formData}
                setFormData={setFormData}
                formSettings={FORM_SETTING_COMPANY_NEWS}
            />

            <button
            disabled={loading || (!formData.permalink || !formData.published_date || !formData.publisher || !formData.title || !formData.url)}
            onClick={() => {
                setLoading(true);
                axiosInstance
                .post(pk? "/news/edit_company_news/":"/news/create_company_news/", {
                    ...formData,pk:pk
                })
                .then((res) => {
                    setLoading(false);
                    toast.success(`News ${pk? 'edited': 'added'} Successfully`)
                    history('/company-news/all')
                })
                .catch((err) => {
                    setLoading(false);
                    console.log(err?.response?.data?.message);
                });
            }}
            className="text-sm bg-black mt-4 disabled:bg-slate-50 disabled:text-black disabled:cursor-not-allowed text-white font-medium px-2 py-1 rounded-md "            
            >Save</button>
            </>}
        </div>
        </div>
    )
}

export default AddEditCompanyNews